import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { kaihoPageMeta, kaihoSchema } from 'components/common/schema'
import Template from 'components/cases/kaiho'

const kaiho: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...kaihoPageMeta} />
      <JsonLd data={kaihoSchema} />
      <Template />
    </>
  )
}

export default kaiho
